import { createEvent, restore } from 'effector';

const setIsBurgerMenuOpen = createEvent<boolean>();
export const openBurgerMenu = setIsBurgerMenuOpen.prepend(() => true);
export const closeBurgerMenu = setIsBurgerMenuOpen.prepend(() => false);

export const $isBurgerMenuOpen = restore(setIsBurgerMenuOpen, false);

$isBurgerMenuOpen.watch((el) => {
  document.body.style.overflow = el ? 'hidden' : 'visible';
  document.body.style.touchAction = el ? 'none' : 'initial';
});
